export default __webpack_public_path__ + "static/media/send_your_queries.3c515b36.svg";